// 权限管理工具
export interface User {
  id: number;
  username: string;
  name: string;
  role: string;
  avatar: string;
}

export interface Permission {
  page: string;
  action: string;
  roles: string[];
}

// 角色定义
export const ROLES = {
  SUPER_ADMIN: 'super_admin',
  ADMIN: 'admin',
  MANAGER: 'manager',
  OPERATOR: 'operator',
  VIEWER: 'viewer'
} as const;

// 权限配置
export const PERMISSIONS: Permission[] = [
  // 仪表盘权限
  { page: 'dashboard', action: 'view', roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER, ROLES.OPERATOR, ROLES.VIEWER] },
  
  // 记忆管理权限
  { page: 'memory', action: 'view', roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER, ROLES.OPERATOR, ROLES.VIEWER] },
  { page: 'memory', action: 'edit', roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER, ROLES.OPERATOR] },
  { page: 'memory', action: 'delete', roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER] },
  { page: 'memory', action: 'export', roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER] },
  
  // 用户画像权限
  { page: 'profile', action: 'view', roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER, ROLES.OPERATOR, ROLES.VIEWER] },
  { page: 'profile', action: 'edit', roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER] },
  { page: 'profile', action: 'delete', roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN] },
  { page: 'profile', action: 'analyze', roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER] },
  
  // 话术管理权限
  { page: 'script', action: 'view', roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER, ROLES.OPERATOR, ROLES.VIEWER] },
  { page: 'script', action: 'edit', roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER, ROLES.OPERATOR] },
  { page: 'script', action: 'delete', roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER] },
  { page: 'script', action: 'test', roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER, ROLES.OPERATOR] },
  
  // 智能体管理权限
  { page: 'agent', action: 'view', roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER, ROLES.OPERATOR, ROLES.VIEWER] },
  { page: 'agent', action: 'edit', roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER] },
  { page: 'agent', action: 'delete', roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN] },
  { page: 'agent', action: 'deploy', roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN] },
  { page: 'agent', action: 'test', roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER, ROLES.OPERATOR] },
  
  // 知识库管理权限
  { page: 'knowledge', action: 'view', roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER, ROLES.OPERATOR, ROLES.VIEWER] },
  { page: 'knowledge', action: 'edit', roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER, ROLES.OPERATOR] },
  { page: 'knowledge', action: 'delete', roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER] },
  { page: 'knowledge', action: 'import', roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER] },
  
  // 工作流管理权限
  { page: 'workflow', action: 'view', roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER, ROLES.OPERATOR, ROLES.VIEWER] },
  { page: 'workflow', action: 'edit', roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER] },
  { page: 'workflow', action: 'delete', roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN] },
  { page: 'workflow', action: 'execute', roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER, ROLES.OPERATOR] },
  
  // 调试工具权限
  { page: 'debug', action: 'view', roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER] },
  { page: 'debug', action: 'simulate', roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER] },
  { page: 'debug', action: 'trace', roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER] },
  
  // 大模型管理权限
  { page: 'model', action: 'view', roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER, ROLES.VIEWER] },
  { page: 'model', action: 'edit', roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN] },
  { page: 'model', action: 'delete', roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN] },
  { page: 'model', action: 'test', roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER] },
  
  // 报表权限
  { page: 'reports', action: 'view', roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER, ROLES.OPERATOR, ROLES.VIEWER] },
  { page: 'reports', action: 'export', roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER] },
  
  // 审计日志权限
  { page: 'audit', action: 'view', roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN] },
  { page: 'audit', action: 'export', roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN] },
  
  // 系统设置权限
  { page: 'settings', action: 'view', roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN] },
  { page: 'settings', action: 'edit', roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN] },

  // 账号管理权限
  { page: 'account', action: 'view', roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN] },
  { page: 'account', action: 'edit', roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN] },
  { page: 'account', action: 'delete', roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN] },
  { page: 'account', action: 'create', roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN] },
  { page: 'account', action: 'export', roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN] },
  { page: 'account', action: 'import', roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN] },

  // 角色管理权限
  { page: 'role', action: 'view', roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN] },
  { page: 'role', action: 'edit', roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN] },
  { page: 'role', action: 'delete', roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN] },
  { page: 'role', action: 'create', roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN] },
  { page: 'role', action: 'permission', roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN] },

  // 菜单管理权限
  { page: 'menu', action: 'view', roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN] },
  { page: 'menu', action: 'edit', roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN] },
  { page: 'menu', action: 'delete', roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN] },
  { page: 'menu', action: 'create', roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN] },
  { page: 'menu', action: 'sort', roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN] },
];

// 权限检查函数
export const hasPermission = (user: User | null, page: string, action: string): boolean => {
  if (!user) return false;
  
  const permission = PERMISSIONS.find(p => p.page === page && p.action === action);
  if (!permission) return false;
  
  return permission.roles.includes(user.role);
};

// 获取用户可访问的页面
export const getAccessiblePages = (user: User | null): string[] => {
  if (!user) return [];
  
  const pages = new Set<string>();
  PERMISSIONS.forEach(permission => {
    if (permission.roles.includes(user.role)) {
      pages.add(permission.page);
    }
  });
  
  return Array.from(pages);
};

// 获取用户角色显示名称
export const getRoleDisplayName = (role: string): string => {
  const roleNames: Record<string, string> = {
    [ROLES.SUPER_ADMIN]: '超级管理员',
    [ROLES.ADMIN]: '系统管理员',
    [ROLES.MANAGER]: '业务管理员',
    [ROLES.OPERATOR]: '操作员',
    [ROLES.VIEWER]: '查看者'
  };
  
  return roleNames[role] || '未知角色';
};

// 检查是否需要二次确认
export const needsConfirmation = (page: string, action: string): boolean => {
  const sensitiveActions = ['delete', 'deploy', 'import', 'export'];
  return sensitiveActions.includes(action);
};

// 操作审计日志
export interface AuditLog {
  id: string;
  userId: number;
  username: string;
  action: string;
  page: string;
  timestamp: number;
  details?: any;
}

export const logAudit = (user: User, page: string, action: string, details?: any) => {
  const log: AuditLog = {
    id: Date.now().toString(),
    userId: user.id,
    username: user.username,
    action,
    page,
    timestamp: Date.now(),
    details
  };
  
  // 保存到localStorage（实际项目中应该发送到服务器）
  const logs = JSON.parse(localStorage.getItem('auditLogs') || '[]');
  logs.push(log);
  localStorage.setItem('auditLogs', JSON.stringify(logs));
  
  console.log('Audit Log:', log);
};
